<template>
  <b-card no-body>
    <b-row class="h-100">
      <b-col class="d-flex flex-column justify-content-between pb-md-2 pb-0">
        <b-card-header >
          <b-card-title >Competition summary</b-card-title>
         
        </b-card-header>
        <b-card-body class="d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-between">
            <div
              class="p-0 mr-50 flex-fill rounded"
              style="background-color: #21212c; overflow: hidden"
            >
              <div class="bg-balance p-2">
                <b-skeleton
                  width="30px"
                  height="20px"
                  class="mb-0"
                  v-if="loading"
                />

                <span class="h1 font-weight-bolder" v-else>{{
                  analytics.competitions_count || "0"
                }}</span>
                <br />
                <span>Total competitions</span>
              </div>
            </div>
            <div
              class="p-0 ml-50 flex-fill rounded"
              style="background-color: #21212c; overflow: hidden"
            >
              <div class="p-2 bg-total-won">
                <b-skeleton
                  width="30px"
                  height="20px"
                  class="mb-0"
                  v-if="loading"
                />
                <span class="h1 font-weight-bolder" v-else>{{
                  analytics.total_participants || "0"
                }}</span>
                <br />
                <span>Total participants</span>
              </div>
            </div>
          </div>
          <template v-if="loading">
            <div
              class="d-flex align-items-center justify-content-between"
              v-for="i in 2"
              :key="i"
            >
              <b-skeleton width="120px" height="20px" class="mb-0" />
              <b-skeleton width="80px" height="20px" class="mb-0" />
            </div>
          </template>
          <template v-else>
            <div
              class="d-flex align-items-center"
              v-for="(competition, index) in analytics.last_competitions"
              :key="index"
            >
              <div class="col-6 pt-1 px-2">
                {{ index + 1 }}. {{ competition.name }}
              </div>
              <div class="col-6 pt-1 px-2">
                {{ competition.participants_count }}
              </div>
            </div>
          </template>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BDropdown,
  BDropdownItem,
  BButton,
  BSkeleton,
} from "bootstrap-vue";
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardTitle,
    BCardHeader,
    BDropdown,
    BDropdownItem,
    BButton,
    BSkeleton,
  },
  data() {
    return {
      years: ["2022", "2021", "2020", "2019"],
    };
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style></style>
